import React, { ChangeEvent } from 'react';
import { useField } from 'react-final-form';

import { Switch } from '@mui/material';

type Props = {
  name: string;
  useNegativeLogic: boolean;
};

export default function SwitchField({ name, useNegativeLogic = false }: Props) {
  const { input } = useField(name);

  const onChange = (event: ChangeEvent<HTMLInputElement>, v: boolean) => {
    input.onChange(useNegativeLogic ? !v : v);
  };

  const checked = useNegativeLogic ? !input.value : Boolean(input.value);
  return <Switch onChange={onChange} checked={checked} />;
}
